import $ from "jquery";

// =============================================================
// Metrics
// =============================================================
if (window.location.href.indexOf("brot-fuer-die-welt.asdocker02") === -1) {
  import("./modules/sentry.module.js").then((module) => {
    module.init();
  });
}

if (window.location.href.indexOf("/newsletter/") > -1) {
  import("./modules/newsletterDL.module.js").then((module) => {
    module.init();
  });
}
// =============================================================
// Modules (direct)
// =============================================================
if (
  document.getElementById("support-anchor") &&
  document.querySelector(".join-wrapper")
) {
  import("./modules/stickySupport.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".youth-header")) {
  import("./modules/youth.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".welt")) {
  import("./modules/karte.module.js").then((module) => {
    module.init();
  });
}

let breadcrumb = document.querySelector(".breadcrumb");
if (breadcrumb) {
  let breadcrumbItems = breadcrumb.querySelectorAll("li");
  if (breadcrumbItems.length > 2) {
    import("./modules/breadcrumbs.module.js").then((module) => {
      module.init();
    });
  }
}

if (document.querySelector(".ce_distruptor .layout-2")) {
  import("./modules/ceDistruptorL2.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".rebrush .flyout-navigation")) {
  import("./modules/flyoutMenuRebrush.module.js").then((module) => {
    module.init();
  });
} else if (document.getElementById("flyout-menu")) {
  import("./modules/flyoutMenu.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".donate-box")) {
  import("./modules/donateBox.module.js").then((module) => {
    module.init();
  });
}

if (
  document.getElementById("leaflet-map") &&
  document.getElementById("location-coordinates")
) {
  import("./modules/leaflet.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".dc_select") ||
  document.getElementById("dc_select_submit") ||
  document.getElementById("dc_id_submit")
) {
  import("./modules/downloadCenter.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".equalizeable") ||
  document.querySelector(".project-title-box") ||
  document.querySelector(".teaser-list div.col") ||
  document.querySelector(".blog-gallery li")
) {
  import("./modules/equalize.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".ce_falfilebrowser") ||
  document.querySelector(".ce_falfilebrowser_searchwords")
) {
  import("./modules/CE/falfilebrowser.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_newsletter_list")) {
  import("./modules/CE/newsletterList.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".news-list-view")) {
  import("./modules/newsListView.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".listtype-sfeventmgt_pieventlist")) {
  import("./modules/eventCalendar.module.js").then((module) => {
    module.init();
  });
}

if (document.getElementById("c13184")) {
  import("./modules/gtm.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".join-steps")) {
  import("./modules/joinSteps.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".collapse")) {
  import("./modules/collapse.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector("[data-feed-url]")) {
  import("./modules/rss.module.js").then((module) => {
    module.init();
  });
}

if (document.getElementById("powermail-email-display")) {
  import("./modules/powermail.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".play-button-big") ||
  document.querySelector(".contact-popup-trigger") ||
  document.querySelector(".play-button") ||
  document.querySelector(".popouterbox")
) {
  import("./modules/popup.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".width-dynamic")) {
  import("./modules/withDynamic.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".resimg")) {
  import("./modules/resimg.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".page-header")) {
  import("./modules/stickyNav.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".searchbox")) {
  import("./modules/searchbox.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".language-box")) {
  import("./modules/languageBox.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".megamenu") ||
  document.getElementById("menu") ||
  document.querySelector(".nav-container")
) {
  import("./modules/mobileMenu.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".ctype-ce_donation_box") ||
  document.querySelector(".ctype-ce_donation_box_one_time") ||
  document.querySelector(".ctype-ce_donation_box_permanent") ||
  document.querySelector(".ctype-ce_donation_box_header")
) {
  import("./modules/CE/donationBox.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_project_help_main_box")) {
  import("./modules/swiper/help.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-home-slider")) {
  import("./modules/swiper/home.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-nit-slider")) {
  import("./modules/swiper/nit.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-tl-slider")) {
  import("./modules/swiper/teaser.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-ge-slider")) {
  import("./modules/swiper/grid.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_donation_teaser")) {
  import("./modules/swiper/donationTeaser.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-itt-slider")) {
  import("./modules/CE/imageTeaserTiles.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".intro-header-section")) {
  import("./modules/introHeaderSection.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".tx-asfilecollection")) {
  import("./modules/TX/asFileCollection.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_themen_von_a_bis_z .search-box")) {
  import("./modules/ceThemenAZ.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".spakt")) {
  import("./modules/spakt.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".image-gallery-box")) {
  import("./modules/swiper/imageGallery.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".scrollytelling")) {
  import("./modules/scrollytelling.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".list_type-asprojectdb_searchform")) {
  import("./modules/TX/asProjectdb.module.js").then((module) => {
    module.init();
  });
}

// -------------------------------------------------------------
// AS header-funtions
// -------------------------------------------------------------
window.setEmailToCookie = function () {
  // Expires in 30s
  let d = new Date(),
    expire = 30000;
  d.setTime(d.getTime() + expire);
  let expires = "expires=" + d.toUTCString();
  document.cookie =
    "powermail-email=" +
    document.getElementById("powermail_field_email").value +
    ";" +
    expires +
    ";";
};

window.getEmailFromCookie = function () {
  let name = "powermail-email=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

// -------------------------------------------------------------
// getUrlVars
// -------------------------------------------------------------
$.extend({
  getUrlVars: function () {
    let vars = [];
    let hash;
    let location = decodeURIComponent(window.location.href);
    let hashes = location
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");

    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function (name) {
    return $.getUrlVars()[name];
  },
});

// -------------------------------------------------------------
// OTHER
// -------------------------------------------------------------
// Remove No-js Class -----------------------------------------------------
// $("html").removeClass("no-js").addClass("js");
// $(".nav > li .dropmenubox").parent("li").addClass("hasnav");

// =============================================================

// -------------------------------------------------------------
let attempts = 0;
const whenComplete = () => {
  if (attempts > 30) return;
  attempts += 1;

  if (document.readyState === "complete") {
    if (document.querySelector(".asp_show")) {
      import("./modules/asPopup.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ctype-asvideogallery_gallery")) {
      import("./modules/asVideoGalleryGallery.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ctype-asvideogallery_single")) {
      import("./modules/asVideoGallerySingle.module.js").then((module) => {
        module.init();
      });
    }

    if (
      (typeof aslCssSelectors !== "undefined" && aslCssSelectors.length > 0) ||
      (typeof aslUrlSelectors !== "undefined" && aslUrlSelectors.length > 0)
    ) {
      import("./modules/exitIntent.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ctype-ce_contact_search")) {
      import("./modules/contactSearch.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".steuerrechner")) {
      import("./modules/steuerrechner.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".newsletter-box")) {
      import("./modules/newsletterBox.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".faq")) {
      import("./modules/gridAccordionFaq.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".twentytwenty-container")) {
      import("./modules/twentytwenty.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ce-image-comparison")) {
      import("./modules/CE/imageComparison.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector("audio")) {
      import("./modules/audio.module.js").then((module) => {
        module.init();
      });
    }

    if (
      document.querySelector(".social-bottom") ||
      document.querySelector(".read-more-panel")
    ) {
      import("./modules/social.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".as-shopware")) {
      import("./modules/shopware.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".fixed-sidebar")) {
      import("./modules/fixedSidebar.module.js").then((module) => {
        module.init();
      });
    }

    if (
      document.querySelector(".privacy_load") ||
      document.querySelector(".privacy_do_load")
    ) {
      import("./modules/CE/privacyHtml.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".tx-asrcclient-pi1")) {
      import("./modules/TX/asRcClient.module.js").then((module) => {
        module.init();
      });
    }

    if (
      document.querySelector(".footer-col h5") ||
      document.querySelector(".footer-links a")
    ) {
      import("./modules/footer.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".lightbox")) {
      import("./modules/lightbox.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector("[data-id='copy-iban']")) {
      import("./modules/func/copyIban.module.js").then((module) => {
        module.init();
      });
    }

    if (document.getElementById("theLink")) {
      import("./modules/func/theLink.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".js--more-items")) {
      import("./modules/func/jsMoreItems.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector("input[data-initial-value]")) {
      import("./modules/func/dataInitialValue.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector("a")) {
      import("./modules/func/linkTargets.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".donate-wrap")) {
      import("./modules/func/donateWrap.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".contact-link a")) {
      import("./modules/func/contactLink.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".scroll-down")) {
      import("./modules/func/scrollDown.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".event-name")) {
      import("./modules/func/eventName.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".donate-amount")) {
      import("./modules/func/donateAmount.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".sub-nav-toggle")) {
      import("./modules/func/subNavToggle.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".material-title")) {
      import("./modules/func/materialTitle.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".scrollto")) {
      import("./modules/func/scrollTo.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".backtotop")) {
      import("./modules/func/backToTop.module.js").then((module) => {
        module.init();
      });
    }

    if (document.getElementById("isSelect")) {
      import("./modules/func/isSelect.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".news-search-form")) {
      import("./modules/func/newsSearchForm.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector("section.download-material")) {
      import("./modules/CE/materialBoxRe.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // on click . touchend
    // -------------------------------------------------------------
    $(window).on("click, touchend", function () {
      if ($(window).width() < 768) {
        $(".nav-container").slideUp("normal");
        $(".nav-container").removeClass("nav-container-open");
        // changes for donations
        $(".page-header input").blur();
      }
    });
    // -------------------------------------------------------------
    // on outside click
    // -------------------------------------------------------------
    if ($("body.rebrush").length > 0) {
      $(window).on("click", function (e) {
        let $lb = $(".language-box");
        if (!$lb.is(e.target) && $lb.has(e.target).length === 0) {
          $lb.removeClass("open");
          $lb.find("ul").slideUp("fast");
        }
        let $fnav = $(".flyout-navigation .nav-item");
        if (!$fnav.is(e.target) && $fnav.has(e.target).length === 0) {
          $(".flyout-navigation .nav-link").removeClass("show");
        }
      });
    }
    // -------------------------------------------------------------
    // on before print
    // -------------------------------------------------------------
    window.addEventListener("beforeprint", () => {
      $("img").attr("loading", "eager").attr("fetchpriority", "high");
    });
    // -------------------------------------------------------------
  } else {
    setTimeout(function () {
      whenComplete();
    }, 400);
  }
};
whenComplete();

let styleAttempts = 0;
const stylesComplete = () => {
  if (styleAttempts > 30) return;
  styleAttempts += 1;

  if ($("#spreld").attr("rel") === "stylesheet") {
    $("[href*='/Public/Stylesheets/styles_essential']").remove();
  } else {
    setTimeout(function () {
      stylesComplete();
    }, 300);
  }
};
stylesComplete();
